var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAplicaIaLogoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon",
    x1: 380,
    y1: 0,
    x2: 475,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A78BFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neonbar",
    x1: 274,
    y1: 268,
    x2: 326,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A78BFA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 32,
    fill: "#0B0F1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 258 310 L 297 198",
    stroke: "#E8ECF4",
    strokeWidth: 15,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 303 198 L 342 310",
    stroke: "#E8ECF4",
    strokeWidth: 15,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274,
    y1: 268,
    x2: 326,
    y2: 268,
    stroke: "url(#neonbar)",
    strokeWidth: 15,
    strokeLinecap: "round",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 172,
    r: 12,
    fill: "#22D3EE",
    filter: "url(#glow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI','DejaVu Sans',Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 430,
    fontSize: 58,
    fontWeight: 600,
    letterSpacing: 6,
    fill: "#E8ECF4",
    textAnchor: "end"
  }, "APLICA"), /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 430,
    fontSize: 58,
    fontWeight: 600,
    letterSpacing: 6,
    fill: "url(#neon)",
    textAnchor: "start"
  }, "IA"), /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 472,
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 8,
    fill: "#8A93A6",
    textAnchor: "middle"
  }, "INTELIG\xCANCIA ARTIFICIAL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicaIaLogoVertical);
export default __webpack_public_path__ + "static/media/aplica-ia-logo-vertical.0d3fcef3dd38e2e4be576e40e37f4672.svg";
export { ForwardRef as ReactComponent };